import Input from '@ui/input';
import { type FC } from 'react';
import styles from './coin-check.module.scss';
import { FixedSizeList } from 'react-window';
import checkboxIcon from '@assets/images/vault/checkbox.svg';
import checkboxSelectedIcon from '@assets/images/vault/checkbox-selected.svg';
import { useVaultCoins } from '@hooks/use-coins';
import { type CoinStruct } from '@models/coins.vault.model';

interface OwnProps {
  data: CoinStruct[];
  addSearch(value: CoinStruct): void;
  removeSearch(value: CoinStruct): void;
  toggleOpenSearch(): void;
  searchName: string;
  onChangeSearchName(value: string): void;
}
const CoinCheck: FC<OwnProps> = ({
  data,
  addSearch,
  removeSearch,
  toggleOpenSearch,
  searchName,
  onChangeSearchName,
}) => {
  const { coins } = useVaultCoins();

  let finalCoins = coins;
  if (searchName) {
    finalCoins = finalCoins.filter(
      (coin) => coin.symbol.toLocaleLowerCase().indexOf(searchName) > -1,
    );
  }

  const handleChange = (coin: CoinStruct) => {
    const isChecked = data.find((item) => coin.coin_type === item.coin_type);
    if (isChecked) {
      removeSearch(coin);
    } else {
      addSearch(coin);
      if (data.length > 0) {
        toggleOpenSearch();
      }
    }
  };

  const Row = ({
    style,
    index,
  }: {
    style: React.CSSProperties;
    index: number;
    isScrolling?: boolean;
  }) => {
    const coin = finalCoins[index]!;
    const isChecked = data.find((item) => coin.coin_type === item.coin_type);
    return (
      <div style={style} className={styles.list} onClick={() => handleChange(coin)}>
        <img src={coin.icon} className={styles.icon} />
        <div className={styles.text}>
          <div>{coin.symbol}</div>
          <div>{coin.name}</div>
        </div>
        <img src={isChecked ? checkboxSelectedIcon : checkboxIcon} />
      </div>
    );
  };

  let _height = finalCoins.length > 4 ? 4 * 64 : finalCoins.length * 64;

  return (
    <div className={styles.wrapper}>
      <div className={styles.input}>
        <Input
          value={searchName}
          placeholder="Search tokens"
          wrapperClassName={styles.wrapperInput}
          onChangeText={onChangeSearchName}
        />
      </div>
      {finalCoins.length <= 0 ? (
        <div className={styles.empty}>
          No token found.<br></br> Please try searching with coinType
        </div>
      ) : (
        <div>
          <FixedSizeList
            useIsScrolling
            height={_height}
            itemCount={finalCoins.length}
            width={'100%'}
            itemSize={64}
          >
            {Row}
          </FixedSizeList>
        </div>
      )}
    </div>
  );
};

export default CoinCheck;
